import { Instance, types } from 'mobx-state-tree';

export const TimetableSlotCount = types
  .model({
    id: types.string,
    classId: types.string,
    availableSlotCount: types.number,
  })
  .actions((self) => ({
    setTimetableSlotCount(newSlotCount: number) {
      self.availableSlotCount = newSlotCount;
    },
  }));

export type TimetableSlotCountModelType = Instance<typeof TimetableSlotCount>;
